module.exports = __webpack_public_path__ + "media/images/athletes/1430-e52baf8dd988a603c5e9c296a6e1f19c.png";